import store from '../store';
import { windowResize, windowScroll } from '../actions/app';

function dispatchResize() {
    store.dispatch(
        windowResize(document.documentElement.clientHeight, document.documentElement.clientWidth)
    );
}

function resizeEvent() {
    window.addEventListener('resize', () => {
        dispatchResize();
    });
}

function getScrollableContainer() {
    return document.querySelector('.main-container');
}

function dispatchScroll() {
    const { scrollTop } = getScrollableContainer();
    store.dispatch(windowScroll(scrollTop));
}

function scroll() {
    getScrollableContainer().addEventListener('scroll', () => {
        dispatchScroll();
    });
}

export default () => {
    resizeEvent();
    dispatchResize();
    scroll();
    dispatchScroll();
};
